// Import all files matching the pattern /bm-*/main.js from the plugins directory
const context = require.context('../../../web/app/plugins/', true, /bm-[^/]+\/main\.js$/);

// Loop through each matched module and import it
context.keys().forEach(context);